module.exports = __webpack_public_path__ + "img/9788965640004.593a0716.jpg";